<template>
  <div style="display: flex;align-items: center">
    <auto-number-input
      v-model="job.cubageContract"
      :precision="3"
      :min="0"
      :disabled="disabled"
      @change="onChange('cubageContract')"
    />
    <span style="padding:0 2px;">/</span>
    <auto-number-input
      v-model="job.cubageActual"
      :precision="3"
      :disabled="disabled"
      :min="0"
      @change="onChange('cubageActual')"
    />
    <span style="min-width: 50px;">CBM</span>
  </div>
</template>

<script>
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'

export default {
  name: 'SeCubageConsignActual',
  components: {
    AutoNumberInput
  },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
